import React, { useEffect } from "react";

function CourseRecommendations({ recommendation, host }) {

  return (
    <div className="courseRecContainer">
      {recommendation.map((rec, index) => (
        <button key={index} className="courseRecBtn">
          <a
            href={`${host}/${rec.Path}`}
            target="_parent" // This will ensure it opens in the parent window
          >
            {rec.Title}
          </a>
        </button>
      ))}
    </div>
  );
}

export default CourseRecommendations;
